import React  from 'react';
import { Route,Switch} from 'react-router-dom';
import Roles from './Roles';
import RolesAddEdit from './Roles/addEdit';
import Menu from './Menu';
import MenuAddEdit from './Menu/addEdit';
import Institution from './Institution';
import InstitutionAddEdit from './Institution/addEdit';
import Branch from './Branch';
import BranchAddEdit from './Branch/addEdit';
import BloodGroup from './BloodGroup';
import BloodGroupAddEdit from './BloodGroup/addEdit';
import Community from './Community';
import CommunityAddEdit from './Community/addEdit';
import Religion from './Religion';
import ReligionAddEdit from './Religion/addEdit'; 
 
export  const Settingroutes = [
    {
        path: '/roles',
        name:'Roles',
        component: Roles,
        show:true,
    },
    {
        path: '/roles-action',
        component: RolesAddEdit
    },
    {
        path: '/roles-action/:id', 
        component: RolesAddEdit
    },
    {
        path: '/menu',
        name:'Menu',
        component: Menu,
        show:true,
    },
    {
        path: '/menu-action',
        component: MenuAddEdit
    },
    {
        path: '/menu-action/:id', 
        component: MenuAddEdit
    },
    {
        path: '/institution',
        name:'Institution',
        component: Institution,
        show:true,
    },
    {
        path: '/institution-action',
        component: InstitutionAddEdit
    },
    {
        path: '/institution-action/:id', 
        component: InstitutionAddEdit
    }, 
    {
        path: '/branch',
        name:'Branch',
        component: Branch,
        show:true,
    },
    {
        path: '/branch-action',
        component: BranchAddEdit
    },
    {
        path: '/branch-action/:id', 
        component: BranchAddEdit
    },
    {
        path: '/blood-group',
        name:'BloodGroup',
        component: BloodGroup,
        show:true,
    },
    {
        path: '/blood-group-action',
        component: BloodGroupAddEdit
    },
    {
        path: '/blood-group-action/:id', 
        component: BloodGroupAddEdit
    }, 
    {
        path: '/community',
        name:'Community',
        component: Community,
        show:true,
    },
    {
        path: '/community-action',
        component: CommunityAddEdit
    },
    {
        path: '/community-action/:id', 
        component: CommunityAddEdit
    }, 
    {
        path: '/religion',
        name:'Religion',
        component: Religion,
        show:true,
    },
    {
        path: '/religion-action',
        component: ReligionAddEdit
    },
    {
        path: '/religion-action/:id', 
        component: ReligionAddEdit
    }
];

const Setting = (props) => {
    return(
        <Switch>
            {Settingroutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Setting; 


// WEBPACK FOOTER //
// ./src/components/Setting/index.js